import { Dispatch, SetStateAction } from 'react';

import { Options } from 'react-select';

import { Option } from '@hsp/react-component-library/types';
import { formatMoney, isEmpty } from '@hsp/utilities';

export const onCreateOptions = (value: string, callback: Dispatch<SetStateAction<Options<Option<string>>>>) => {
  const label = formatMoney(value, 2);

  if (isEmpty(label)) {
    return;
  }
  const option = { label, value };

  callback((state) => [...state, option]);
};
